import axios from "axios";
import { RecentlyViewedHotelResponse } from "redmond";
import { config, recentlyViewedAxiosCancelToken } from "../../config";
import { recentlyViewedApiPrefix } from "../../paths";
const END_POINT: string = `${recentlyViewedApiPrefix}/hotels`;

export const fetchRecentlyViewedHotels =
  (): Promise<RecentlyViewedHotelResponse> =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(END_POINT, {
          baseURL: config.baseURL,
          cancelToken: recentlyViewedAxiosCancelToken.token,
        });
        resolve(res.data);
      } catch (e) {
        if (axios.isCancel(e)) {
          // do not reject if the error is a cancellation from the cancel token
          return;
        }
        reject(e);
      }
    });
